export default {
  'Your win': 'Tu victoria',
  'Select skins that you want to take': 'Selecciona las pieles que quieres coger',
  'By price': 'Por precio',
  '(Autotrade will receive after 10 minutes)':
    '(El intercambio automático recibirá pasados 10 minutos)',
  ACCEPT: 'Confirmar',
  'SELECT ALL': 'SELECT ALL',
};
